import { isClient } from '../../common/utils';

export class ErrorStorage {
  static key = 'consentError';

  static setError = () => {
    if (isClient()) {
      window.sessionStorage.setItem(ErrorStorage.key, 'true');
    }
  };

  static clearError = () => {
    if (isClient()) {
      window.sessionStorage.removeItem(ErrorStorage.key);
    }
  };

  static hasError = () => {
    if (isClient()) {
      const value = window.sessionStorage.getItem(ErrorStorage.key);
      return value === 'true';
    }
    return false;
  };
}
